(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["why-choose-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.why-choose-us');
    const items = document.querySelectorAll('.why-choose-us_item-tags li');

    if (!section || !items.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // remove all classes first
            items.forEach((item) => {
              item.classList.remove('show');
            });

            // re-add with delay
            items.forEach((item, index) => {
              setTimeout(() => {
                item.classList.add('show');
              }, index * 250);
            });
          } else {
            // when section goes out of screen
            // reset animation again
            items.forEach((item) => {
              item.classList.remove('show');
            });
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();
})();
